module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-align-to-center-vertical.c86a29a8844fa842b217c1132d6ff2d8.svg";